import { render, staticRenderFns } from "./title.vue?vue&type=template&id=0ff1fb10&scoped=true"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"
import style0 from "./title.vue?vue&type=style&index=0&id=0ff1fb10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff1fb10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff1fb10')) {
      api.createRecord('0ff1fb10', component.options)
    } else {
      api.reload('0ff1fb10', component.options)
    }
    module.hot.accept("./title.vue?vue&type=template&id=0ff1fb10&scoped=true", function () {
      api.rerender('0ff1fb10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/title.vue"
export default component.exports